

import React, {useEffect, useState, useRef} from 'react';
import { Nav } from 'reactstrap';
import Scrollbar from 'react-scrollbars-custom';
import { useSelector } from 'react-redux'
import Flex from "../../../components/common/Flex";
import classNames from 'classnames';
import {connect} from  "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons'; // Import the spinner icon
import {socket} from '../Main/socket'
import { Card, CardBody,TabContent, TabPane, Input, FormGroup, Form, Media, UncontrolledTooltip, Button, Col, Row } from 'reactstrap';
import axios from "axios"
import  {crmdata} from "../../../Redux/Actions/USER/user"
import { useHistory } from "react-router-dom";
// Import the twilioErrorDetails.json file
import twilioErrorDetails from './twilioErrorDetails.json';  // Adjust path if needed
import { toast } from 'react-toastify';

import { sendmessage } from '../../../Redux/Actions/Twilio';
var moment = require('moment-timezone');
const ChatSidebar = ({sendmessage, crmdata}) => {
    const chatRef=useRef()
    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState(null)
    const [contact, setcontact] = useState([])
    const [isOpenThreadInfo, setIsOpenThreadInfo] = useState(false);
    const [id, setActiveID] = useState(0)
    const [scrollHeight, setScrollHeight] = useState(0);
    const [textAreaInitialHeight, setTextAreaInitialHeight] = useState(32);
    const [search, setSearch] = useState("")
    const isMountedRef = useRef(null);
    const history = useHistory()
    const currtz=useSelector(state=>state.Twilio.timezone)

    const inputRef = useRef(null);
    const messageSendingID = useRef(null);

    const chatScrollRef = useRef(null);


    const [loading, setLoading] = useState(false); // To track loading state for API call



 // Timer state to wait for 2 seconds after input is emptied
 const [timer, setTimer] = useState(null);

// Handle input change and start the timer if input is emptied
const handleInputChange = ({ target }) => {
  setSearch(target.value); // Update search state on input change

  // If input is emptied, start a timer for 2 seconds
  if (target.value === '') {
    if (timer) clearTimeout(timer); // Clear existing timer
    setTimer(setTimeout(() => apiCall(''), 2000)); // Call apiCall after 2 seconds if empty
    setSearch("")

  } else {
    // If user starts typing again, reset the timer to prevent calling apiCall
    if (timer) clearTimeout(timer);
  }
};

 

    const handleSubmit = e => {
        e.preventDefault();
        console.log("inbound",message)
        sendmessage(messages.sender, message, messages.number);
        setMessage("")


  // // Delay the if condition by 5 seconds
  //   setTimeout(() => {
  //       if (messageSendingID.current === id) {
  //           selectmessage(messageSendingID.current);
  //       }
  //   }, 5000); // 5000 milliseconds = 5 seconds


   // Reset textarea height
   if (inputRef.current) {
    inputRef.current.style.height = '2.2rem';
  }

  // Reset form container height
  const formEl = inputRef.current?.closest('.chat-editor-area');
  if (formEl) {
    formEl.style.height = 'auto';
  }
    };
     const crmdet  = () =>{
        crmdata(id)
    }
   
    // const searchcontact = (e)=>{
    //     e.preventDefault();
    //     if(search !=""){
    //         apiCall(search)
    //     }else{
    //         apiCall("")

    //     }
        
    // }
    useEffect(()=>{
      setcontact([])
       if(search != "")
       {
         apiCall(search)
       }
       else{
         apiCall("")
       }
      
    },[])



    const searchContact = (e) => {
      setcontact([])

      e.preventDefault(); // Prevent default form submission behavior
      if (search !== "") {
          apiCall(search); // Trigger API call when search is not empty
      } else {
          apiCall(""); // Trigger API call with an empty search
      }
  };
  
 useEffect(() => {
    // Ensure connection is established first
    socket.on('connect', () => {
      console.log('Socket connected in User Chat message!');
    });

    socket.on('undeliveredMessage', async (data) => {
      console.log("exist From Chat=================================", data);
      selectmessage(id);

      if (data.status === 'undelivered') {
        // Fetch the error details from the JSON file based on the ErrorCode
        const errorCodeNum = Number(data.ErrorCode);
        const error = twilioErrorDetails.find(item => item.code === errorCodeNum);

        if (errorCodeNum === 30034) {
          // If the ErrorCode is 30034, show a custom message with registration link

          toast.error(
            <div>
              Your recent message could not be delivered because your number {data.from} is not registered under A2P 10DLC. 
              Please complete your registration <a href="https://call.mergeasy.com/hub" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Here</a>.
            </div>
          );



        } else {
          // For other error codes, display a generic message
          toast.error(`${error?.message || error?.description || 'Failed to send message!'}`);
        }
      }
    });

    // Cleanup on unmount or disconnection
    return () => {
      socket.off('undeliveredMessage'); // Unsubscribe to avoid memory leaks
      socket.off('connect');
    };
  }, []);


  const handleKeyDown = (e) => {

      if (e.key === "Enter") {
          searchContact(e); // Trigger search when Enter key is pressed
      }
  };

  // const apiCall = async (search) => {
//     try {
//         let msg = await axios({
//             method: "get",
//             url: `${process.env.REACT_APP_PORT}/api/me/contacts?search=${search}`,
//             headers: {
//                 "x-auth-token": localStorage.getItem("token"),
//             },
//         });

//         let dd = msg.data.data;
//         console.log(dd);
//         if (id !== 0) {
//             console.log(id);
//             socket.emit("getmessageid", localStorage.getItem("email"), id, "contact");
//         } else {
//             socket.emit("getmessageid", localStorage.getItem("email"), dd[0]._id, "contact");
//         }
//         setcontact(dd); // Update contact state with the fetched contacts
//     } catch (e) {
//         console.log("error", e); // Handle any errors from the API call
//     }
// };



    const apiCall = async(search)=>{
      try{
        setLoading(true); // Set loading to true while API call is in progress
         // Remove special characters (non-alphanumeric characters)
         const sanitizedSearch = search.replace(/[^a-zA-Z0-9 ]/g, '');
         
          let msg =  await axios({
              method: 'get',
              url: process.env.REACT_APP_PORT + '/api/me/contacts?search='+sanitizedSearch,
              headers: {
                'x-auth-token': localStorage.getItem('token')
              } 
            });
          let dd = msg.data.data
          console.log(dd)
          // if(id != 0)
          // {
          //     console.log(id)
              
          // socket.emit('getmessageid', localStorage.getItem('email'), id, "contact");
          // }
          // else{
          //     socket.emit('getmessageid', localStorage.getItem('email'), dd[0]._id, "contact");
          // }
          setcontact(dd)

          if(dd.length>0)
          {
            setActiveID(dd[0]._id)
            selectmessage(dd[0]._id)
          }
        }
        catch(e){
            console.log("error", e)
        }finally {
          setLoading(false); // Set loading to false after API call completes
          setSearch("")
        }
  }

    useEffect(()=>{
        socket.once('message', async(data) => {
            console.log(data)
            if(data){
              // const sanitizedSearch = search.replace(/[^a-zA-Z0-9 ]/g, '');
              //  let contact =  await axios({
              //      method: 'get',
              //      url: process.env.REACT_APP_PORT + '/api/me/contacts?search='+sanitizedSearch,
              //      headers: {
              //        'x-auth-token': localStorage.getItem('token')
              //      } 
              //    });
              //  let dd = contact.data.data
              //  setcontact(dd)
              
               let msg =  await axios({
                   method: 'get',
                   url: process.env.REACT_APP_PORT + '/api/me/message?id='+data,
                   headers: {
                     'x-auth-token': localStorage.getItem('token')
                   }
                 });
                let response = msg.data.data
                   if (response._id == data) {
                  
                       setMessages(response);
                    
                   }
           }
         }); 
    }, [messages])


    // const crmdet  = () =>{
    //     crmdata(id)
    // }
    const CallRedirect = ()=>{
        let path = `/pages/call?to=${messages.sender}&from=${messages.number}`
        history.push(path)
    }
    const remove = (data)=>{
        socket.emit("delete", localStorage.getItem("email"), data, id)
    }

    // socket.once("contact", async(msg)=> {
    //   try{
    //     let msg =  await axios({
    //         method: 'get',
    //         url: process.env.REACT_APP_PORT + '/api/me/contacts',
    //         headers: {
    //           'x-auth-token': localStorage.getItem('token')
    //         } 
    //       });
    //     let dd = msg.data.data
    //     if(id != 0)
    //     {
    //         console.log(id)
    //     socket.emit('getmessageid', localStorage.getItem('email'), id, "contact");
    //     }
    //     else{
    //         socket.emit('getmessageid', localStorage.getItem('email'), dd[0]._id, "contact");
    //     }
    //     setcontact(dd)
    //   }
    //   catch(e){
    //       console.log("error", e)
    //   }
        
    // })
   
    const selectmessage = async(id)=>{
        setMessages(null)
        let msg =  await axios({
            method: 'get',
            url: process.env.REACT_APP_PORT + '/api/me/message?id='+id,
            headers: {
              'x-auth-token': localStorage.getItem('token')
            }
          });
         let response = msg.data.data
            if (response._id == id) {
              
                setMessages(response);
        }
    }
    
    useEffect(() => {
        //TextBox and message body height controlling
        isMountedRef.current = true;
        let textAreaPreviousHeight = textAreaInitialHeight;
        const autoExpand = function (field) {
            // Reset field height
            field.style.height = '2rem';

            // Calculate the height
            const textAreaCurrentHeight = field.scrollHeight;

            if (textAreaCurrentHeight <= 160 && document.querySelector('.card-chat-pane')) {
                if (textAreaPreviousHeight !== textAreaCurrentHeight && isMountedRef.current) {
                    document.querySelector('.card-chat-pane').style.height = `calc(100% - ${textAreaCurrentHeight}px)`;
                    setTextAreaInitialHeight((textAreaPreviousHeight = textAreaCurrentHeight));
                }
            }

            field.style.height = textAreaCurrentHeight + 'px';
        };
        if (document.querySelector('.textarea')) {
            document.addEventListener(
                'input',
                function (event) {
                    if (event.target.className === 'textarea');
                    autoExpand(event.target);
                },
                false
            );
        }
        return () => {
            isMountedRef.current = false;
        };
    }, [textAreaInitialHeight, setTextAreaInitialHeight]);


  

    useEffect(() => {

    const temp1=chatRef.current
    if(temp1){
        temp1.scroll(0,temp1.scrollHeight)
    }
    }, [messages?.messages,chatRef])
    
    return (
         <Card style={{height:"80vh",width:'65vw'}} className="container">
            <CardBody tag={Flex} className="p-0 h-100">
                  

<div className="chat-sidebar rounded-left">
        {/* <div className="contacts-list bg-white">
            <Scrollbar
                style={{
                    height: "100%",
                    minWidth: "75px",
                }}
                noScrollX
                trackYProps={{
                    renderer(props) {
                        const { elementRef, ...restProps } = props;
                        return <span {...restProps} ref={elementRef} className="TrackY" />;
                    },
                }}
            >
                <Nav className="border-0">
                {contact && contact.length > 0 ? (
                contact.map((item) => (
                  
                  <Media
                            key={item._id}
                            className={classNames(`chat-contact hover-actions-trigger w-100`, {
                                active: item._id === id,
                            })}
                            onClick={() => {
                                setActiveID(item._id);
                                selectmessage(item._id);
                                document.getElementsByClassName("chat-sidebar")[0].style.left = "-100%";
                            }}
                        >
                            <Media body className="chat-contact-body ml-2 d-md-none d-lg-block">
                                <Flex justify="between">
                                    <h6 className="mb-0 chat-contact-title">{item.sender}</h6>
                                    <span className="message-time fs--2"> </span>
                                </Flex>
                                <div className="min-w-0">
                                    <div className="chat-contact-content pr-3">
                                        {item.messages[item.messages.length - 1]?.body}
                                    </div>
                                </div>
                            </Media>
                        </Media>
    ))
  ) : (
                          // Render text if contacts array is empty
                     
<>
{loading ? (
          <FontAwesomeIcon icon={faSpinner} spin className="fs--1" 
          style={{ 
            fontSize: '2rem', 
            color: '#03A9D6' }} // Increase size and change color to blue

          /> // Use faSpinner for the loader
        ) : (
          <div className="no-contacts-text" style={{ textAlign: 'center', padding: '20px', color: 'gray' }}>
          No Contacts
          </div>

        )}

</>
                  )}
                </Nav>
            </Scrollbar>
        </div> */}

<div className="contacts-list bg-white">
    <Scrollbar
        style={{
            height: "100%",
            minWidth: "75px",
        }}
        noScrollX
        trackYProps={{
            renderer(props) {
                const { elementRef, ...restProps } = props;
                return <span {...restProps} ref={elementRef} className="TrackY" />;
            },
        }}
    >
        <Nav className="border-0">
            <>
                {loading ? (
                    // Show the loader when loading is true
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <FontAwesomeIcon 
                            icon={faSpinner} 
                            spin 
                            className="fs--1" 
                            style={{ 
                                fontSize: '2rem', 
                                color: '#03A9D6'  // Blue color for the loader
                            }} 
                        />
                    </div>
                ) : contact && contact.length === 0 ? (
                    // Show "No Contacts" if the contacts array is empty
                    <div className="no-contacts-text" style={{ textAlign: 'center', padding: '20px', color: 'gray' }}>
                        No Conversation Found
                    </div>
                ) : (
                    // Render the contact list if it's not empty
                    contact.map((item) => (
                        <Media
                            key={item._id}
                            className={classNames(`chat-contact hover-actions-trigger w-100`, {
                                active: item._id === id,
                            })}
                            onClick={() => {
                                setActiveID(item._id);
                                selectmessage(item._id);
                                document.getElementsByClassName("chat-sidebar")[0].style.left = "-100%";
                            }}
                        >
                            <Media body className="chat-contact-body ml-2 d-md-none d-lg-block">
                                <Flex justify="between">
                                    <h6 className="mb-0 chat-contact-title">{item.sender}</h6>
                                    <span className="message-time fs--2"> </span>
                                </Flex>
                                <div className="min-w-0">
                                    <div className="chat-contact-content pr-3">
                                        {item.messages[item.messages.length - 1]?.body}
                                    </div>
                                </div>
                            </Media>
                        </Media>
                    ))
                )}
            </>
        </Nav>
    </Scrollbar>
</div>

        <Form className="chat-editor-area bg-white" >
            <Input
             onChange={handleInputChange} // Update search state on input change
                // onChange={({ target }) => setSearch(target.value)} // Update search state on input change
                onKeyDown={handleKeyDown} // Call search on Enter key press
                className="border-0 outline-none shadow-none resize-none textarea bg-white"
                type="text" // Changed to 'text' for single-line input
                style={{
                    height: "2.2rem", // Ensure the height is fixed for a single-line input
                    maxHeight: "2.2rem", // Ensure no height increase
                    overflow: "hidden", // Prevent vertical overflow
                }}
                placeholder="Search contacts ..."
                bsSize="sm"
                disabled={loading} // Disable input while loading
            />
            <Button
                color="transparent"
                size="sm"
                className={classNames(`btn-send outline-none ml-1`, {
                    "text-primary": message.length > 0,
                })}
                type="submit"
                disabled={loading} // Disable button while loading
            >
 {/* Conditionally render either the search icon or a loader */}
 {loading ? (
          <FontAwesomeIcon icon={faSpinner} spin className="fs--1" 
          style={{ 
            // fontSize: '2rem', 
            color: '#03A9D6' }} // Increase size and change color to blue

          /> // Use faSpinner for the loader
        ) : (
          <FontAwesomeIcon icon="search" className="fs--1"  />
        )}
        
        </Button>
        </Form>
    </div>



                                { messages && contact.length > 0 && 
                                
                                <TabContent className="card-chat-content fs--1 position-relative"
                                
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  height: '100%', // Or fixed height like '500px' or 'calc(100vh - header height)'
                                }}


                                > <TabPane className="card-chat-pane active" 
                                style={{
                                  flex: 1,
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                                
                                >
                                  

<div className="chat-content-header">
  <Row className="d-flex justify-content-between align-items-center w-100 m-0">
    {/* Left Side */}
    <div className="d-flex align-items-center" style={{ flex: 1 }}>
      <div
        className="pr-3 text-700 d-md-none contacts-list-show cursor-pointer"
        onClick={() => (document.getElementsByClassName('chat-sidebar')[0].style.left = 0)}
      >
        <FontAwesomeIcon icon="chevron-left" />
      </div>
      <div className="min-w-0">
        <h5 className="mb-0 text-truncate fs-0">To: {messages && messages.sender}</h5>
        <h5 className="mb-0 text-truncate fs-0">SMS ID: {messages && messages.number}</h5>
        <div className="fs--2 text-400">
        </div>
      </div>
    </div>

    {/* Right Side */}
    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
      {/* <Button onClick={crmdet} color="falcon-primary" size="sm" id="call-tooltips">
        CRM
        <UncontrolledTooltip placement="left" target="call-tooltips" innerClassName="fs--1">
          Push to CRM
        </UncontrolledTooltip>
      </Button> */}


        <Button onClick={crmdet} color="falcon-primary" size="sm" id="call-tooltips">
        CRM
        <UncontrolledTooltip placement="left" target="call-tooltips" innerClassName="fs--1">
          Push to CRM
        </UncontrolledTooltip>
      </Button>

      <Button onClick={CallRedirect} color="falcon-primary" size="sm" id="call-tooltip">
        <FontAwesomeIcon icon="phone" />
        <UncontrolledTooltip placement="left" target="call-tooltip" innerClassName="fs--1">
          Start an Audio Call
        </UncontrolledTooltip>
      </Button>
      {/* <Button
        color="falcon-primary"
        size="sm"
        id="info-tooltip"
        onClick={() => setIsOpenThreadInfo(prevState => !prevState)}
      >
        <FontAwesomeIcon icon="info" />
        <UncontrolledTooltip placement="left" target="info-tooltip" innerClassName="fs--1">
          Conversation Information
        </UncontrolledTooltip>
      </Button> */}
    </div>
  </Row>
</div>


                                    <div className="chat-content-body" 
                                    
                                    style={{
                                      flex: 1,
                                      overflowY: 'auto',
                                      padding: '10px 0',
                                      paddingBottom: '75px'
                                    }}
                                    
                                    >
                                    <div className="chat-content-scroll-area"   ref={chatRef}>

                                                {messages &&  messages.messages.map((item, index) => (
                                                        <div key={index}>
                                                            <div className="text-center fs--2 text-500">{`${moment(item.createdAt).tz(currtz).format('LLL')}`}</div>
                                                        <Flex
                                                            align="center"
                                                            className={classNames('hover-actions-trigger px-1', {
                                                                'justify-content-end': item.direction != "outbound-api" ? false : true
                                                            })}
                                                        >
                                                     
                                                        <div
                                                                className={classNames('p-2 rounded-soft ', {
                                                                                'bg-200': item.direction == "outbound-api" ? false : true,
                                                                                'bg-primary text-white': item.direction != "outbound-api" ? false : true
                                                                })}
                                                                        >
                                                                <p className="mb-0"
                                                                  style={{ 
                                                                    overflowWrap: 'anywhere',                                                                     whiteSpace: 'pre-wrap', 
                                                                    maxWidth: '100%' 
                                                                  }}
                                                                
                                                                >{item.body}</p>
{/* Conditionally render the "Undelivered" message */}
 {item.status === "undelivered" && (
                    <span
                        style={{
                            color: 'red',
                            fontSize: '8px',
                            position: 'absolute',
                            bottom: '-18px', // Position it at the bottom of the message bubble
                            right: '10px', // Position it to the right
                            marginBottom:'5px'
                        }}
                    >
                        Undelivered
                    </span>
                )}


                                                            </div>
                                                    
                                                        </Flex>


                                                    
                                                    
                                                        </div>
                                                ))}
                                            
                                            </div>
                                       
                                    </div>
                                    </TabPane>



                                    <Form className="chat-editor-area bg-white" 
                                    // onSubmit={handleSubmit}

                                    onSubmit={(e) => {
                                      e.preventDefault(); // Prevent default form submission behavior
                                      messageSendingID.current = id; // Set the ref to id instantly before calling handleSubmit
                                      handleSubmit(e); // Call the handleSubmit function
                                    }}
                                    
                                    style={{
                                      display: 'flex',
                                      alignItems: 'flex-end',
                                      padding: '8px',
                                      borderTop: '1px solid #ddd'
                                    }}
                                    
                                    >
  <Input
    innerRef={inputRef}
    className="border-0 outline-none shadow-none resize-none textarea bg-white"
    type="textarea"
    placeholder="Type your message"
    bsSize="sm"
    value={message}
    onChange={(e) => {
      setMessage(e.target.value);
    
    }}
    style={{
      height: '3.2rem', // fixed height
      flexGrow: 1,
      resize: 'none',
      overflowY: 'auto', // if multiline, scroll inside
      padding: '6px 10px',
      lineHeight: '1.4',
      borderRadius: '6px',
      maxHeight: '4.8rem', // prevent over-expansion
    }}
  />
  <Button
    color="transparent"
    size="sm"
    type="submit"
    style={{
      marginLeft: '8px',
      marginBottom: '4px',
      padding: '6px 12px',
      fontWeight: 'bold',
      color: message.length > 0 ? '#007bff' : '#999'
    }}
  >
    Send
  </Button>
</Form>
                             
                                
                            </TabContent>
                            }

            </CardBody>
      </Card>
         
    );
};
export default connect(
    null,
    { sendmessage, crmdata}
  )(ChatSidebar);




// import React, {useEffect, useState, useRef} from 'react';
// import { Nav } from 'reactstrap';
// import Scrollbar from 'react-scrollbars-custom';
// import { useSelector } from 'react-redux'
// import Flex from "../../../components/common/Flex";
// import classNames from 'classnames';
// import {connect} from  "react-redux";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {socket} from '../Main/socket'
// import { Card, CardBody,TabContent, TabPane, Input, FormGroup, Form, Media, UncontrolledTooltip, Button, Col, Row } from 'reactstrap';
// import axios from "axios"
// import { toast } from 'react-toastify';
// // Import the twilioErrorDetails.json file
// import twilioErrorDetails from './twilioErrorDetails.json';  // Adjust path if needed
// import  {crmdata} from "../../../Redux/Actions/USER/user"
// import { useHistory } from "react-router-dom";
// import { sendmessage } from '../../../Redux/Actions/Twilio';
// var moment = require('moment-timezone');
// const ChatSidebar = ({sendmessage, crmdata}) => {
//     const chatRef=useRef()
//     const [message, setMessage] = useState('');
//     const [messages, setMessages] = useState(null)
//     const [contact, setcontact] = useState([])
//     const [isOpenThreadInfo, setIsOpenThreadInfo] = useState(false);
//     const [id, setActiveID] = useState(0)
//     const [scrollHeight, setScrollHeight] = useState(0);
//     const [textAreaInitialHeight, setTextAreaInitialHeight] = useState(32);
//     const [search, setSearch] = useState("")
//     const isMountedRef = useRef(null);
//     const history = useHistory()
//     const currtz=useSelector(state=>state.Twilio.timezone)

//     const inputRef = useRef(null);
//     const chatScrollRef = useRef(null);


//     const handleSubmit = e => {
//         e.preventDefault();
//         console.log("inbound",message)
//         sendmessage(messages.sender, message, messages.number);
//         setMessage("")

//    // Reset textarea height
//    if (inputRef.current) {
//     inputRef.current.style.height = '2.2rem';
//   }

//   // Reset form container height
//   const formEl = inputRef.current?.closest('.chat-editor-area');
//   if (formEl) {
//     formEl.style.height = 'auto';
//   }
//     };
   
   
//     // const searchcontact = (e)=>{
//     //     e.preventDefault();
//     //     if(search !=""){
//     //         apiCall(search)
//     //     }else{
//     //         apiCall("")

//     //     }
        
//     // }
//     useEffect(()=>{
//       setcontact([])
//        if(search != "")
//        {
//          apiCall(search)
//        }
//        else{
//          apiCall("")
//        }
      
//     },[])



//     const searchContact = (e) => {
//       setcontact([])

//       e.preventDefault(); // Prevent default form submission behavior
//       if (search !== "") {
//           apiCall(search); // Trigger API call when search is not empty
//       } else {
//           apiCall(""); // Trigger API call with an empty search
//       }
//   };
  
//   const handleKeyDown = (e) => {

//       if (e.key === "Enter") {
//           searchContact(e); // Trigger search when Enter key is pressed
//       }
//   };

//   // const apiCall = async (search) => {
// //     try {
// //         let msg = await axios({
// //             method: "get",
// //             url: `${process.env.REACT_APP_PORT}/api/me/contacts?search=${search}`,
// //             headers: {
// //                 "x-auth-token": localStorage.getItem("token"),
// //             },
// //         });

// //         let dd = msg.data.data;
// //         console.log(dd);
// //         if (id !== 0) {
// //             console.log(id);
// //             socket.emit("getmessageid", localStorage.getItem("email"), id, "contact");
// //         } else {
// //             socket.emit("getmessageid", localStorage.getItem("email"), dd[0]._id, "contact");
// //         }
// //         setcontact(dd); // Update contact state with the fetched contacts
// //     } catch (e) {
// //         console.log("error", e); // Handle any errors from the API call
// //     }
// // };



//     const apiCall = async(search)=>{
//       try{
//           let msg =  await axios({
//               method: 'get',
//               url: process.env.REACT_APP_PORT + '/api/me/contacts?search='+search,
//               headers: {
//                 'x-auth-token': localStorage.getItem('token')
//               } 
//             });
//           let dd = msg.data.data
//           console.log(dd)
//           if(id != 0)
//           {
//               console.log(id)
//           socket.emit('getmessageid', localStorage.getItem('email'), id, "contact");
//           }
//           else{
//               socket.emit('getmessageid', localStorage.getItem('email'), dd[0]._id, "contact");
//           }
//           setcontact(dd)
//         }
//         catch(e){
//             console.log("error", e)
//         }
//   }

//   // useEffect(()=>{
//   //   socket.on('undeliveredMessage', async(data) => {

//   //     console.log("exist From Chat=================================",data)
//   //     selectmessage(id)
//   //     if(data.status=='undelivered'){
//   //       toast.error(`Failed to send message!`);

//   //     }
//   //   })
//   //   }, [])


//   useEffect(() => {
//     // Ensure connection is established first
//     socket.on('connect', () => {
//       console.log('Socket connected in User Chat message!');
//     });

//     socket.on('undeliveredMessage', async (data) => {
//       console.log("exist From Chat=================================", data);
//       selectmessage(id);

//       if (data.status === 'undelivered') {
//         // Fetch the error details from the JSON file based on the ErrorCode
//         const errorCodeNum = Number(data.ErrorCode);
//         const error = twilioErrorDetails.find(item => item.code === errorCodeNum);

//         if (errorCodeNum === 30034) {

//           // If the ErrorCode is 30034, show a custom message with registration link
//           toast.error(
//             <div>
//               Your recent message could not be delivered because your number {data.from} is not registered under A2P 10DLC. 
//               Please complete your registration <a href="https://call.mergeasy.com/hub" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Here</a>.
//             </div>
//           );

//         } else {
//           // For other error codes, display a generic message
//           toast.error(`${error?.message || error?.description || 'Failed to send message!'}`);
//         }
//       }
//     });

//     // Cleanup on unmount or disconnection
//     return () => {
//       socket.off('undeliveredMessage'); // Unsubscribe to avoid memory leaks
//       socket.off('connect');
//     };
//   }, []);

// //   useEffect(() => {
// //     // Ensure connection is established first
// //     socket.on('connect', () => {
// //         console.log('Socket connected!');
// //     });

// //     socket.on('undeliveredMessage', async (data) => {
// //         console.log("exist From Chat=================================", data);
// //         selectmessage(id);
// //         if (data.status === 'undelivered') {
// //             toast.error(`Failed to send message!`);
// //         }
// //     });

// //     // Cleanup on unmount or disconnection
// //     return () => {
// //         socket.off('undeliveredMessage'); // Unsubscribe to avoid memory leaks
// //         socket.off('connect');
// //     };
// // }, []);

//     useEffect(()=>{
//         socket.once('message', async(data) => {
//             console.log(data)
//             if(data){
//                let contact =  await axios({
//                    method: 'get',
//                    url: process.env.REACT_APP_PORT + '/api/me/contacts?search='+search,
//                    headers: {
//                      'x-auth-token': localStorage.getItem('token')
//                    } 
//                  });
//                let dd = contact.data.data
//                setcontact(dd)
//                let msg =  await axios({
//                    method: 'get',
//                    url: process.env.REACT_APP_PORT + '/api/me/message?id='+data,
//                    headers: {
//                      'x-auth-token': localStorage.getItem('token')
//                    }
//                  });
//                 let response = msg.data.data
//                    if (response._id == data) {
//                        setMessages(response);
//                    }
//            }
//          }); 
//     }, [messages])
//     const crmdet  = () =>{
//         crmdata(id)
//     }
//     const CallRedirect = ()=>{
//         let path = `/pages/call?to=${messages.sender}&from=${messages.number}`
//         history.push(path)
//     }
//     const remove = (data)=>{
//         socket.emit("delete", localStorage.getItem("email"), data, id)
//     }
//     socket.once("contact", async(msg)=> {
//       try{
//         let msg =  await axios({
//             method: 'get',
//             url: process.env.REACT_APP_PORT + '/api/me/contacts',
//             headers: {
//               'x-auth-token': localStorage.getItem('token')
//             } 
//           });
//         let dd = msg.data.data
//         if(id != 0)
//         {
//             console.log(id)
//         socket.emit('getmessageid', localStorage.getItem('email'), id, "contact");
//         }
//         else{
//             socket.emit('getmessageid', localStorage.getItem('email'), dd[0]._id, "contact");
//         }
//         setcontact(dd)
//       }
//       catch(e){
//           console.log("error", e)
//       }
        
//     })
   
//     const selectmessage = async(id)=>{
//         setMessages(null)
//         let msg =  await axios({
//             method: 'get',
//             url: process.env.REACT_APP_PORT + '/api/me/message?id='+id,
//             headers: {
//               'x-auth-token': localStorage.getItem('token')
//             }
//           });
//          let response = msg.data.data
//             if (response._id == id) {
//                 setMessages(response);
//         }
//     }
    
//     useEffect(() => {
//         //TextBox and message body height controlling
//         isMountedRef.current = true;
//         let textAreaPreviousHeight = textAreaInitialHeight;
//         const autoExpand = function (field) {
//             // Reset field height
//             field.style.height = '2rem';

//             // Calculate the height
//             const textAreaCurrentHeight = field.scrollHeight;

//             if (textAreaCurrentHeight <= 160 && document.querySelector('.card-chat-pane')) {
//                 if (textAreaPreviousHeight !== textAreaCurrentHeight && isMountedRef.current) {
//                     document.querySelector('.card-chat-pane').style.height = `calc(100% - ${textAreaCurrentHeight}px)`;
//                     setTextAreaInitialHeight((textAreaPreviousHeight = textAreaCurrentHeight));
//                 }
//             }

//             field.style.height = textAreaCurrentHeight + 'px';
//         };
//         if (document.querySelector('.textarea')) {
//             document.addEventListener(
//                 'input',
//                 function (event) {
//                     if (event.target.className === 'textarea');
//                     autoExpand(event.target);
//                 },
//                 false
//             );
//         }
//         return () => {
//             isMountedRef.current = false;
//         };
//     }, [textAreaInitialHeight, setTextAreaInitialHeight]);


  

//     useEffect(() => {

//     const temp1=chatRef.current
//     if(temp1){
//         temp1.scroll(0,temp1.scrollHeight)
//     }
//     }, [messages?.messages,chatRef])
    
//     return (
//          <Card style={{height:"80vh",width:'65vw'}} className="container">
//             <CardBody tag={Flex} className="p-0 h-100">
//                     {/* <div className="chat-sidebar rounded-left">
//                         <div className="contacts-list bg-white">
//                         <Scrollbar
//                             style={{
//                                 height: '100%',
//                                 minWidth: '75px'
//                             }}
//                             noScrollX
//                             trackYProps={{
//                                 renderer(props) {
//                                 const { elementRef, ...restProps } = props;
//                                 return <span {...restProps} ref={elementRef} className="TrackY" />;
//                                 }
//                             }}
//                         >
//                     <Nav className="border-0">
//                         {contact && contact.length > 0 && contact.map(item => <Media key={item._id}
//                             className={classNames(`chat-contact hover-actions-trigger w-100 `,{
//                                 active: item._id === id
//                               })}
//                             onClick={() => {
//                                 setActiveID(item._id)
//                                 selectmessage(item._id)
//                             document.getElementsByClassName('chat-sidebar')[0].style.left = '-100%';
//                                 }}>
                                             
//                             <Media body className="chat-contact-body ml-2 d-md-none d-lg-block">
//                                 <Flex justify="between">
//                                     <h6 className="mb-0 chat-contact-title">{item.sender}</h6>
//                                     <span className="message-time fs--2">  </span>
//                                 </Flex>
//                                     <div className="min-w-0">
//                                         <div className="chat-contact-content pr-3"
//                                         >{item.messages[item.messages.length -1]?.body}</div>

//                                     </div>
//                             </Media>
//                             </Media>)}
//                         </Nav>
//                                     </Scrollbar>
                            
//                         </div>
//                         <Form className="chat-editor-area bg-white" onSubmit={searchcontact}>
//                                 <Input  onChange={({ target }) => setSearch(target.value)}  className="border-0 outline-none shadow-none resize-none textarea bg-white"
//                                     type="textarea"
                                    
                                    
//                                     style={{
//                                         height: '2.2rem',
//                                         maxHeight: '10rem'
//                                     }}
//                                     placeholder="Search contacts ..." bsSize="sm" />
                                
//                                      <Button
//                                     color="transparent"
//                                     size="sm"
//                                     className={classNames(`btn-send outline-none ml-1`, {
//                                         'text-primary': message.length > 0
//                                     })}
//                                     type="submit"
//                                 >
//                                       <FontAwesomeIcon icon="search" className="fs--1" />
//                                 </Button>
                                
//                             </Form>

//                             </div> */}

// <div className="chat-sidebar rounded-left">
//         <div className="contacts-list bg-white">
//             <Scrollbar
//                 style={{
//                     height: "100%",
//                     minWidth: "75px",
//                 }}
//                 noScrollX
//                 trackYProps={{
//                     renderer(props) {
//                         const { elementRef, ...restProps } = props;
//                         return <span {...restProps} ref={elementRef} className="TrackY" />;
//                     },
//                 }}
//             >
//                 <Nav className="border-0">
//                     {contact && contact.length > 0 && contact.map((item) => (
//                         <Media
//                             key={item._id}
//                             className={classNames(`chat-contact hover-actions-trigger w-100`, {
//                                 active: item._id === id,
//                             })}
//                             onClick={() => {
//                                 setActiveID(item._id);
//                                 selectmessage(item._id);
//                                 document.getElementsByClassName("chat-sidebar")[0].style.left = "-100%";
//                             }}
//                         >
//                             <Media body className="chat-contact-body ml-2 d-md-none d-lg-block">
//                                 <Flex justify="between">
//                                     <h6 className="mb-0 chat-contact-title">{item.sender}</h6>
//                                     <span className="message-time fs--2"> </span>
//                                 </Flex>
//                                 <div className="min-w-0">
//                                     <div className="chat-contact-content pr-3">
//                                         {item.messages[item.messages.length - 1]?.body}
//                                     </div>
//                                 </div>
//                             </Media>
//                         </Media>
//                     ))}
//                 </Nav>
//             </Scrollbar>
//         </div>
//         <Form className="chat-editor-area bg-white" onSubmit={searchContact}>
//             <Input
//                 onChange={({ target }) => setSearch(target.value)} // Update search state on input change
//                 onKeyDown={handleKeyDown} // Call search on Enter key press
//                 className="border-0 outline-none shadow-none resize-none textarea bg-white"
//                 type="text" // Changed to 'text' for single-line input
//                 style={{
//                     height: "2.2rem", // Ensure the height is fixed for a single-line input
//                     maxHeight: "2.2rem", // Ensure no height increase
//                     overflow: "hidden", // Prevent vertical overflow
//                 }}
//                 placeholder="Search contacts ..."
//                 bsSize="sm"
//             />
//             <Button
//                 color="transparent"
//                 size="sm"
//                 className={classNames(`btn-send outline-none ml-1`, {
//                     "text-primary": message.length > 0,
//                 })}
//                 type="submit"
//             >
//                 <FontAwesomeIcon icon="search" className="fs--1" />
//             </Button>
//         </Form>
//     </div>



//                                 { messages && contact.length > 0 && 
                                
//                                 <TabContent className="card-chat-content fs--1 position-relative"
                                
//                                 style={{
//                                   display: 'flex',
//                                   flexDirection: 'column',
//                                   height: '100%', // Or fixed height like '500px' or 'calc(100vh - header height)'
//                                 }}


//                                 > <TabPane className="card-chat-pane active" 
//                                 style={{
//                                   flex: 1,
//                                   display: 'flex',
//                                   flexDirection: 'column'
//                                 }}
                                
//                                 >
                                  

// <div className="chat-content-header">
//   <Row className="d-flex justify-content-between align-items-center w-100 m-0">
//     {/* Left Side */}
//     <div className="d-flex align-items-center" style={{ flex: 1 }}>
//       <div
//         className="pr-3 text-700 d-md-none contacts-list-show cursor-pointer"
//         onClick={() => (document.getElementsByClassName('chat-sidebar')[0].style.left = 0)}
//       >
//         <FontAwesomeIcon icon="chevron-left" />
//       </div>
//       <div className="min-w-0">
//         <h5 className="mb-0 text-truncate fs-0">To: {messages && messages.sender}</h5>
//         <h5 className="mb-0 text-truncate fs-0">SMS ID: {messages && messages.number}</h5>
//         <div className="fs--2 text-400">
//         </div>
//       </div>
//     </div>

//     {/* Right Side */}
//     <div className="d-flex align-items-center" style={{ gap: '8px' }}>
//       <Button onClick={crmdet} color="falcon-primary" size="sm" id="call-tooltips">
//         CRM
//         <UncontrolledTooltip placement="left" target="call-tooltips" innerClassName="fs--1">
//           Push to CRM
//         </UncontrolledTooltip>
//       </Button>
//       <Button onClick={CallRedirect} color="falcon-primary" size="sm" id="call-tooltip">
//         <FontAwesomeIcon icon="phone" />
//         <UncontrolledTooltip placement="left" target="call-tooltip" innerClassName="fs--1">
//           Start an Audio Call
//         </UncontrolledTooltip>
//       </Button>
//       <Button
//         color="falcon-primary"
//         size="sm"
//         id="info-tooltip"
//         onClick={() => setIsOpenThreadInfo(prevState => !prevState)}
//       >
//         <FontAwesomeIcon icon="info" />
//         <UncontrolledTooltip placement="left" target="info-tooltip" innerClassName="fs--1">
//           Conversation Information
//         </UncontrolledTooltip>
//       </Button>
//     </div>
//   </Row>
// </div>


//                                     <div className="chat-content-body" 
                                    
//                                     // style={{ display: 'inherit',paddingBottom: '50px'  }}
//                                     style={{
//                                       flex: 1,
//                                       overflowY: 'auto',
//                                       padding: '10px 0',
//                                       paddingBottom: '75px'
//                                     }}
                                    
//                                     >
//                                     <div className="chat-content-scroll-area"   ref={chatRef}>

//                                                 {messages &&  messages.messages.map((item, index) => (
//                                                         <div key={index}>
//                                                             <div className="text-center fs--2 text-500">{`${moment(item.createdAt).tz(currtz).format('LLL')}`}</div>
//                                                         <Flex
//                                                             align="center"
//                                                             className={classNames('hover-actions-trigger px-1', {
//                                                                 'justify-content-end': item.direction != "outbound-api" ? false : true
//                                                             })}
//                                                         >
                                                     
//                                                         <div
//                                                                 className={classNames('p-2 rounded-soft ', {
//                                                                                 'bg-200': item.direction == "outbound-api" ? false : true,
//                                                                                 'bg-primary text-white': item.direction != "outbound-api" ? false : true
//                                                                 })}
//                                                                         >
//                                                                 <p className="mb-0"
//                                                                   style={{ 
//                                                                     overflowWrap: 'anywhere',                                                                     whiteSpace: 'pre-wrap', 
//                                                                     maxWidth: '100%' 
//                                                                   }}
                                                                
//                                                                 >{item.body}</p>

//  {/* Conditionally render the "Undelivered" message */}
//  {item.status === "undelivered" && (
//                     <span
//                         style={{
//                             color: 'red',
//                             fontSize: '8px',
//                             position: 'absolute',
//                             bottom: '-18px', // Position it at the bottom of the message bubble
//                             right: '10px', // Position it to the right
//                             marginBottom:'5px'
//                         }}
//                     >
//                         Undelivered
//                     </span>
//                 )}
//                                                             </div>
                                                    
//                                                         </Flex>


                                                    
                                                    
//                                                         </div>
//                                                 ))}
                                            
//                                             </div>
                                       
//                                     </div>
//                                     </TabPane>



//                                     <Form className="chat-editor-area bg-white" onSubmit={handleSubmit}
                                    
//                                     style={{
//                                       display: 'flex',
//                                       alignItems: 'flex-end',
//                                       padding: '8px',
//                                       borderTop: '1px solid #ddd'
//                                     }}
                                    
//                                     >
//   <Input
//     innerRef={inputRef}
//     className="border-0 outline-none shadow-none resize-none textarea bg-white"
//     type="textarea"
//     placeholder="Type your message"
//     bsSize="sm"
//     value={message}
//     onChange={(e) => {
//       setMessage(e.target.value);
    
//     }}
//     style={{
//       height: '3.2rem', // fixed height
//       flexGrow: 1,
//       resize: 'none',
//       overflowY: 'auto', // if multiline, scroll inside
//       padding: '6px 10px',
//       lineHeight: '1.4',
//       borderRadius: '6px',
//       maxHeight: '4.8rem', // prevent over-expansion
//     }}
//   />
//   <Button
//     color="transparent"
//     size="sm"
//     type="submit"
//     style={{
//       marginLeft: '8px',
//       marginBottom: '4px',
//       padding: '6px 12px',
//       fontWeight: 'bold',
//       color: message.length > 0 ? '#007bff' : '#999'
//     }}
//   >
//     Send
//   </Button>
// </Form>
                             
                                
//                             </TabContent>
//                             }

//             </CardBody>
//       </Card>
         
//     );
// };
// export default connect(
//     null,
//     { sendmessage, crmdata}
//   )(ChatSidebar);
